export function stringToDate(date) {
  if (date && typeof date === 'string') {
    if (date.indexOf('/Date') === 0) {
      date = date.replace('/Date(', '');
      date = date.replace(')/', '');
      return new Date(parseInt(date, 10) || date);
    } else {
      return new Date(date);
    }
  } else {
    return undefined;
  }
}

export function buildRouteName({ routeQualityStatus, routeName, date }) {
  if (!(routeQualityStatus && routeName && date)) return '';
  
  //check if data is date, if so, convert to string
  if (date instanceof Date) {
    date = date.toString();
  }
  // remove time from date string and concatenate to format YYYYMMDD
  const dateString = date.split('T')[0];
  
  const [yearStr, monthStr, dayStr] = dateString.split('-');
  const validityPeriodStart = yearStr + monthStr + dayStr;

  return `${routeQualityStatus}_${routeName}_${validityPeriodStart}.rtz`;
}
